'use client';

import { useTranslations } from 'next-intl';

import Link from '@/lib/translation/components/link';

const RecaptchaLegals = () => {
  const t = useTranslations();
  return (
    <p className="text-sm text-muted-foreground">
      {t('auth.recaptcha.description')}
      <Link
        className="text-primary underline"
        href="https://policies.google.com/privacy"
        target="_blank"
      >
        {t('auth.recaptcha.privacyPolicy')}
      </Link>
      {t('auth.recaptcha.and')}
      <Link
        className="text-primary underline"
        href="https://policies.google.com/terms"
        target="_blank"
      >
        {t('auth.recaptcha.terms')}
      </Link>
      {t('auth.recaptcha.apply')}
    </p>
  );
};

export default RecaptchaLegals;
